import { useEffect } from 'react';
import Footer from '../layout/Footer';
import Section from '../layout/Section';

const LegalPage = ({ title, content }) => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="bg-[#0a0a0a] min-h-screen flex flex-col">
            <Section className="flex-grow pt-32 pb-20">
                <div className="container mx-auto px-4 md:px-6 max-w-4xl">
                    <div className="bg-white/5 border border-white/10 rounded-2xl p-8 md:p-12 shadow-2xl backdrop-blur-sm">
                        <h1 className="text-3xl md:text-4xl font-heading font-bold text-gray-200 mb-8 border-b border-white/10 pb-6">
                            {title}
                        </h1>
                        <div className="space-y-6 text-gray-400 leading-relaxed font-light">
                            {content.map((paragraph, index) => {
                                // Check if paragraph is a header (ends with :)
                                const isHeader = paragraph.trim().endsWith(':');
                                return isHeader ? (
                                    <h3 key={index} className="text-xl font-heading font-semibold text-accent-gold/90 mt-6 mb-2">
                                        {paragraph}
                                    </h3>
                                ) : (
                                    <p key={index} className="text-base md:text-lg">
                                        {paragraph}
                                    </p>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </Section>
            <Footer />
        </div>
    );
};

export default LegalPage;
